import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VersionHistory = ({ versions, loading, onRestore, onClose }) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-lg w-full max-w-2xl max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-4 md:px-6 py-4 border-b border-border">
          <h2 className="text-lg md:text-xl font-semibold text-foreground">Version History</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-muted transition-colors"
            aria-label="Close version history"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin mr-3"></div>
              <span className="text-sm text-muted-foreground">Loading versions...</span>
            </div>
          ) : versions?.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <Icon name="History" size={40} className="text-muted-foreground mb-3" />
              <p className="text-sm font-medium text-foreground mb-1">No versions yet</p>
              <p className="text-xs text-muted-foreground">Save this page to start tracking version history</p>
            </div>
          ) : (
            <div className="space-y-3 md:space-y-4">
              {versions?.map((version) => (
                <div
                  key={version?.id}
                  className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg border border-border hover:border-primary/50 transition-colors"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold text-sm">
                    {version?.author?.split(' ')?.map(n => n?.[0])?.join('')?.toUpperCase() || '?'}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <div>
                        <p className="text-sm font-medium text-foreground">{version?.author}</p>
                        <p className="text-xs text-muted-foreground">{formatDate(version?.timestamp)}</p>
                      </div>
                      {version?.isCurrent && (
                        <span className="px-2 py-0.5 text-xs font-medium bg-primary/10 text-primary rounded">
                          Current
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-muted-foreground mb-2">{version?.changes}</p>
                    {!version?.isCurrent && (
                      <Button
                        variant="outline"
                        size="sm"
                        iconName="RotateCcw"
                        iconPosition="left"
                        onClick={() => onRestore(version?.id)}
                      >
                        Restore
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VersionHistory;